import { render } from "./Thickness.vue?vue&type=template&id=e5e10668&scoped=true"
import script from "./Thickness.vue?vue&type=script&lang=js"
export * from "./Thickness.vue?vue&type=script&lang=js"

import "./Thickness.vue?vue&type=style&index=0&id=e5e10668&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5e10668"]])

export default __exports__